module.exports = require("css.escape");


//////////////////
// WEBPACK FOOTER
// external "css.escape"
// module id = 480
// module chunks = 0